import React from 'react';
import NewUniProfile from 'pages/NewUniProfile';
import CreateUniProfile from 'pages/CreateUniProfilePage';
import useProviderServiceFlag from 'hooks/useProviderServiceFlag';

export default function UniProfileEntry() {
    const [flag] = useProviderServiceFlag();
    const isKlarity = !!flag?.klarityServiceFlag;

    return (
        <>
            {isKlarity ? <CreateUniProfile /> : <NewUniProfile />}
        </>
    );
}
